<h2 mat-dialog-title style="margin-bottom: 8px">{{ data.title }}</h2>

<div class="dialog-search-wrapper">
  <mat-form-field
    appearance="outline"
    style="width: 100%"
    subscriptSizing="dynamic"
  >
    <mat-label>Search drinks...</mat-label>
    <input
      matInput
      type="text"
      placeholder="Filter by drink or brewery..."
      [(ngModel)]="searchTerm"
    />
    @if (searchTerm) {
      <button
        matSuffix
        mat-icon-button
        type="button"
        aria-label="Clear search"
        (click)="searchTerm = ''"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
</div>

<div mat-dialog-content style="max-height: 400px; overflow-y: auto">
  @if (filteredBeers.length === 0) {
    <div
      style="padding: 20px; text-align: center; color: #888; font-style: italic"
    >
      No drinks found for this selection matching your search.
    </div>
  }
  <ul style="padding-left: 0; list-style-type: none">
    @for (beer of filteredBeers; track beer.beerName + $index) {
      <li style="margin-bottom: 16px">
        <a
          [href]="beer.checkinUrl"
          target="_blank"
          style="
            text-decoration: none;
            color: inherit;
            display: flex;
            align-items: center;
            padding: 8px;
            border-radius: 8px;
            transition: background-color 0.2s ease;
          "
          [style.cursor]="beer.checkinUrl ? 'pointer' : 'default'"
          class="beer-item-link"
          (mouseenter)="
            $any($event.target).style.backgroundColor = 'rgba(255,255,255,0.05)'
          "
          (mouseleave)="
            $any($event.target).style.backgroundColor = 'transparent'
          "
        >
          <img
            [src]="
              beer.beerLabel ||
              'https://assets.untappd.com/site/assets/images/temp/badge-beer-default.png'
            "
            [alt]="beer.beerName"
            style="
              width: 54px;
              height: 54px;
              margin-right: 12px;
              object-fit: cover;
              border-radius: 4px;
            "
          />
          <div style="flex: 1; min-width: 0">
            <strong
              style="
                color: var(--accent-glow, #ffca28);
                display: block;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              "
              >{{ beer.beerName }}</strong
            >
            <strong
              style="
                color: white;
                font-size: 0.9em;
                display: block;
                opacity: 0.9;
              "
              >{{ beer.breweryName }}</strong
            >
            <div style="font-size: 0.8em; opacity: 0.7; margin-top: 2px">
              <span>ABV: {{ beer.beerABV }}%</span> •
              <span>Rating: {{ beer.rating.toFixed(2) }}/5</span>
            </div>
            <div style="font-size: 0.75em; opacity: 0.6">
              {{ formatDate(beer.checkInDate) }}
            </div>
          </div>
          @if (beer.checkinUrl) {
            <mat-icon
              style="
                font-size: 18px;
                width: 18px;
                height: 18px;
                opacity: 0.5;
                margin-left: 8px;
              "
              >open_in_new</mat-icon
            >
          }
        </a>
      </li>
    }
  </ul>
</div>

<div mat-dialog-actions align="end">
  @if (data.showBackButton) {
    <button mat-button [mat-dialog-close]="'back'">
      <mat-icon>arrow_back</mat-icon> Back
    </button>
  }
  <button mat-button mat-dialog-close>Close</button>
</div>
